import { formatAsCurrency, finiteOrZero } from './utilities';

export const Calculator = function () {
  //   store values of inputs from calculator form
  this.formValues = {};

  //   get values from form and store into formValues
  this.getFormValues = (nodeList) =>
    nodeList.forEach((input) => (this.formValues[input.id] = input.value));

  //   update individual form value
  this.updateFormValues = (id, value) => {
    value ? (this.formValues[id] = value) : (this.formValues[id] = 0);
  };

  this.getDocumentationTimeSavingsPerDay = () => {
    return this.formValues.documentationTime / 2;
  };

  this.getHoursSavedPerDay = () => {
    const totalDocTimeDaily =
      this.formValues.documentationTime * this.formValues.appointmentsPerDay;
    const timeSavedPerDay =
      this.getDocumentationTimeSavingsPerDay() *
      this.formValues.appointmentsPerDay;
    const total = (totalDocTimeDaily - timeSavedPerDay) / 60;
    return total;
  };

  this.getHoursSavedPerMonth = () => {
    const total = this.getHoursSavedPerDay() * 20;
    return total;
  };

  this.getMonthlyRevOpportunity = () => {
    const hourlyRevenue =
      ((this.getHoursForNewPatients() * 60) /
        this.formValues.appointmentLength) *
      this.formValues.revenuePerAppointment;
    return hourlyRevenue;
  };

  this.getAnnualRevOpportunity = () => {
    const annualRevenue = this.getMonthlyRevOpportunity() * 12;
    return annualRevenue;
  };

  this.getHoursForNewPatients = () => {
    const addPatientPercent = this.formValues.additionalHoursPercent / 100;
    const hoursToSpend = this.getHoursSavedPerMonth() * addPatientPercent;
    return hoursToSpend;
  };

  this.getAdditionalPatientThroughput = () => {
    const minsToSpend = this.getHoursForNewPatients() * 60;
    const additionalShifts = Math.floor(
      minsToSpend / this.formValues.appointmentLength
    );
    return additionalShifts;
  };

  this.getHoursForPersonalTime = () => {
    const addPersonalPercent = (100 - this.formValues.additionalHoursPercent) / 100;
    const addPersonalHours = this.getHoursSavedPerMonth() * addPersonalPercent;
    return addPersonalHours;
  };
};
